import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable()
export class WelcomeService {

    private messageSource = new BehaviorSubject('');
    currentMessage = this.messageSource.asObservable();

  private resourceUrl = environment.apiUrl + 'subscriber';

  constructor(private http: HttpClient) {}

    changeMessage(message: string) {
        this.messageSource.next(message)
    }

  getSubscriber(idSubscriber): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/' + environment.eventKey + '/' + idSubscriber);
  }

  getSubscriberList(): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/list');
  }

  saveSubscriber(request: any, idSubscriber: any): Observable<any> {
    return this.http.post<any>(this.resourceUrl + '/' + environment.eventKey + '/' + idSubscriber, request);
  }


  getHeader(idSubscriber): Observable<any[]> {
    return this.http.get<any[]>(this.resourceUrl + '/' + idSubscriber + '/header');
  }

  loadImage(id: number, file: File): Observable<any> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<any[]>(this.resourceUrl + '/' + environment.eventKey + '/' + id + '/photo/web', formData, {observe: 'response'});
  }

  deleteImage(idSubscriber): Observable<any> {
    return this.http.delete<any>(this.resourceUrl + '/' + environment.eventKey + '/' + idSubscriber + '/photo', {});
  }

  getEventDetail(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'eventSetting/' + environment.eventKey + '/parameter');
  }

  getEventFields(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + 'eventSubscriberField/' + environment.eventKey + '/list/website');
  }

}
